<template>
<widget title="Pricing Defaults"
	icon="fa-dollar-sign">

	<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

	<p>Apply a default Price Adjustment and Markup to billable elements. These can be over-ridden by specific Customer Settings, and adjusted on an invoice or bid individually as required.</p>

	<vue-form :no-top-button="true" v-on:submit="save" :working="pricingFormWorking">


		<table class="table table-borderless">
			<tr>
				<td></td>
				<th>Price Adjustment</th>
				<th>Markup</th>
			</tr>
			<tr v-for="(element,key) in payload">
				<th>{{ labels[key] }}</th>
				<td>
					<field 
						:params="{
							type:'number',
							min:0,step:0.001,
							placeholder: 'ex. 1.20 for 20% adjustment'
						}"
						v-model="payload[key].price_adjustment">
					</field>
				</td>
				<td>
					<field 
						:params="{
							type:'number',
							min:0,step:0.001,
							placeholder: 'ex. 1.20 for 20% markup'
						}"
						v-model="payload[key].markup">
					</field>
				</td>
			</tr>
			<tr>
				<td></td>
				<td colspan="2"><p>The value you enter is a simple multiplier, so for example for a 20% markup, enter the value of 1.20</p></td>
			</tr>
		</table>

	</vue-form>

</widget>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import Field from "@/components/Field"
import VueForm from "@/components/VueForm"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"

export default {
	name: "PricingDefaultsWidget",
	components: {
		Field,
		VueForm,
		Widget,
		FreemiumLockedAlert
	},
	data() {
		return {
			labels: {
				Material: "Material",
				Labour: "Labour",
				Equipment: "Equipment",
				SupplierQuote: "Supplier Quotes"
			},
			payload: {
				Material: {
					price_adjustment: 1,
					markup: 1
				},
				Labour: {
					price_adjustment: 1,
					markup: 1
				},
				Equipment: {
					price_adjustment: 1,
					markup: 1
				},
				SupplierQuote: {
					price_adjustment: 1,
					markup: 1
				}
			},
			pricingFormWorking: false
		}
	},
	watch: {
		'$store.company.CompanySetting'() {
			this.setPayload()
		}
	},
	methods: {
		setPayload() {
			if ("CompanySetting" in this.$store.company && this.$store.company.CompanySetting) {
				let payload = {}, vm = this
				try {
					payload = JSON.parse(this.$store.company.CompanySetting.default_pricing_json)
				}
				catch (e) {}

				Object.keys(this.payload).forEach(key => {
					if (key in payload && payload[key]) {
						if ("price_adjustment" in payload[key] && payload[key].price_adjustment)
							this.payload[key].price_adjustment = payload[key].price_adjustment
						if ("markup" in payload[key] && payload[key].markup)
							this.payload[key].markup = payload[key].markup
					}
				})
			}
		},
		save() {
			let vm = this

			let payload = {
				default_pricing_json: JSON.stringify(this.payload)
			}

			this.pricingFormWorking = true

			this.postData("CompanySetting/save",payload,true).then(response => {
				vm.pricingFormWorking = false
				if (response.success) {
					vm.alertSaved("Settings saved")
					vm.fetchCompanySettings()
				}
			})
		}
	},
	created() {
		this.setPayload()
	}
}
</script>